import { useQuery } from '@tanstack/react-query'
import { meQuery } from './api'

/** Platform permission keys, as granted by the operator's role (App\Domain\Platform\Access). */
export type PlatformPermission =
  | 'tenants.view'
  | 'tenants.manage'
  | 'tenants.suspend'
  | 'plans.view'
  | 'plans.manage'
  | 'billing.view'
  | 'billing.manage'
  | 'domains.view'
  | 'support.access'
  | 'backups.view'
  | 'backups.manage'
  | 'announcements.view'
  | 'announcements.manage'
  | 'users.view'
  | 'users.manage'
  | 'audit.view'
  | 'system.queues'
  | 'settings.view'
  | 'settings.manage'

/**
 * `can('plans.manage')` for the signed-in operator. Only hides what the role
 * cannot use; the API enforces every permission itself.
 */
export function useCan(): (permission: PlatformPermission) => boolean {
  const { data: me } = useQuery(meQuery)
  return (permission) => me?.permissions.includes(permission) ?? false
}
